import React, { ReactNode } from 'react'
import { DragDropContext, DragUpdate, Droppable, DropResult } from 'react-beautiful-dnd'

interface Props {
  droppableId: string
  children: ReactNode | ReactNode[]
  onDragEnd: (result: DropResult) => void
  onDragStart?: (start: any) => void
  onDragUpdate?: (update: DragUpdate) => void
  isDropDisabled?: boolean
}

const DragAndDropList: React.FC<Props> = ({
  droppableId,
  children,
  onDragEnd,
  onDragStart,
  onDragUpdate,
  isDropDisabled,
}) => (
  <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart} onDragUpdate={onDragUpdate}>
    <Droppable droppableId={droppableId} isDropDisabled={isDropDisabled}>
      {(provided) => (
        <div ref={provided.innerRef} {...provided.droppableProps}>
          {children}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  </DragDropContext>
)

export default DragAndDropList
